import type {
  GenericTrackingEvent,
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinFormSubmitClick,
} from '@packages/tracking/src/types/events';
import type {
  GlycerinButtonClickPayload,
  GlycerinFormSubmitClickPayload,
} from '@packages/tracking/src/types/payloads';

export interface DispatchButtonTrackingProps {
  /** The event dispatcher. */
  eventDispatcher: <T extends GenericTrackingEvent>(event: T) => void;
  /** The type of the button. */
  type: HTMLButtonElement['type'];
  /** Optional click tracking properties. */
  clickTrackingProps?: GlycerinButtonClickPayload | GlycerinFormSubmitClickPayload;
}

export const dispatchButtonTracking = (props: DispatchButtonTrackingProps) => {
  const { eventDispatcher, type, clickTrackingProps } = props;
  const { category, target, detail, label, placement, variantIds, custom } =
    clickTrackingProps ?? {};

  if (type === 'submit') {
    eventDispatcher<GTMEventGlycerinFormSubmitClick>({
      event: 'FormSubmitClick',
      FormSubmitClickData: {
        category: category ?? 'form-submit-click',
        target,
        detail,
        label,
        placement,
        formId:
          clickTrackingProps && 'formId' in clickTrackingProps
            ? clickTrackingProps.formId
            : undefined,
        variantIds,
        custom,
      },
    });
  } else {
    eventDispatcher<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: category ?? 'button-click',
        target,
        detail,
        label,
        placement,
        variantIds,
        custom,
      },
    });
  }
};
